export const FIELDS = {
  'kColorProduct': {
    localization: {
      id: "kColorProduct",
      defaultMessage: "Prodotto",
    },
  },
  'color': {
    localization: {
      id: "color",
      defaultMessage: "Colore",
    },
  },
  'productPackage': {
    localization: {
      id: "productPackage",
      defaultMessage: "Confezione",
    },
  },
}